export const color = {
    brand: {
        5: '#FDECF2',
        10: '#FBD5E1',
        20: '#F8AAC3',
        30: '#F480A5',
        40: '#F05687',
        50: '#ED2E69',
        60: '#D81351',
        70: '#AE0F41',
        80: '#7F0B30',
        90: '#550720',
        95: '#3D0517',
    },
    gray: {
        5: '#F5F5F5',
        10: '#E8E8E8',
        20: '#D1D1D1',
        30: '#BABABA',
        40: '#A3A3A3',
        50: '#8C8C8C',
        60: '#757575',
        70: '#616161',
        80: '#494949',
        90: '#2E2E2E',
        95: '#212121',
    },
    white: {
        0: '#FFFFFF',
        5: '#FFFFFF0D',
        10: '#FFFFFF1A',
        20: '#FFFFFF33',
        30: '#FFFFFF4D',
        40: '#FFFFFF66',
        50: '#FFFFFF80',
        60: '#FFFFFF99',
        70: '#FFFFFFB2',
        80: '#FFFFFFCC',
        90: '#FFFFFFE5',
        95: '#FFFFFFF2',
    },
    black: {
        0: '#000000',
        5: '#0000000D',
        10: '#0000001A',
        20: '#00000033',
        30: '#0000004D',
        40: '#00000066',
        50: '#00000080',
        60: '#00000099',
        70: '#000000B2',
        80: '#000000CC',
        90: '#000000E5',
        95: '#000000F2',
    },
};

export const spacing = {
    0: '0px',
    1: '1px',
    2: '2px',
    4: '4px',
    6: '6px',
    8: '8px',
    10: '10px',
    12: '12px',
    16: '16px',
    20: '20px',
    24: '24px',
    32: '32px',
    40: '40px',
    48: '48px',
    56: '56px',
    64: '64px',
    80: '80px',
    96: '96px',
    128: '128px',
    160: '160px',
};

export const fontWeight = {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
};

export const fontSize = {
    10: '0.625rem',
    12: '0.75rem',
    13: '0.8125rem',
    14: '0.875rem',
    15: '0.9375rem',
    16: '1rem',
    18: '1.125rem',
    20: '1.25rem',
    24: '1.5rem',
    26: '1.625rem',
    28: '1.75rem',
    32: '2rem',
    36: '2.25rem',
    40: '2.5rem',
    44: '2.75rem',
};

export const lineHeight = {
    110: 1.1,
    115: 1.15,
    120: 1.2,
    125: 1.25,
    130: 1.3,
    150: 1.5,
};

export const letterSpacing = {
    negative025: '-0.25px',
    negative05: '-0.5px',
    negative075: '-0.75px',
    negative1: '-1px',
};

export const borderRadius = {
    0: '0px',
    4: '4px',
    6: '6px',
    8: '8px',
    12: '12px',
    16: '16px',
    round: '9999px',
};

export const borderWidth = {
    0: '0px',
    1: '1px',
    2: '2px',
    4: '4px',
    8: '8px',
};

export const opacity = {
    0: 0,
    5: 0.05,
    10: 0.1,
    20: 0.2,
    30: 0.3,
    40: 0.4,
    50: 0.5,
    60: 0.6,
    70: 0.7,
    80: 0.8,
    90: 0.9,
    100: 1,
};

export const shadowSharp = {
    1: '0 0 0 1px rgb(0 0 0 / 0.05), 0 1px 2px -1px rgb(0 0 0 / 0.05), 0 1px 4px 0 rgb(0 0 0 / 0.05)',
    2: '0 0 0 1px rgb(0 0 0 / 0.05), 0 2px 4px -2px rgb(0 0 0 / 0.05), 0 4px 8px -2px rgb(0 0 0 / 0.05)',
    3: '0 0 0 1px rgb(0 0 0 / 0.05), 0 4px 8px -2px rgb(0 0 0 / 0.05), 0 8px 16px -2px rgb(0 0 0 / 0.05)',
    4: '0 0 0 1px rgb(0 0 0 / 0.05), 0 12px 48px -6px rgb(0 0 0 / 0.2)',
};

export const shadowSoft = {
    1: '0 1px 2px -1px rgb(0 0 0 / 0.05), 0 1px 4px 0 rgb(0 0 0 / 0.05)',
    2: '0 2px 4px -2px rgb(0 0 0 / 0.05), 0 4px 8px -2px rgb(0 0 0 / 0.05)',
    3: '0 4px 8px -2px rgb(0 0 0 / 0.05), 0 8px 16px -2px rgb(0 0 0 / 0.05)',
    4: '0 12px 48px -6px rgb(0 0 0 / 0.2)',
};

export const breakpoints = {
    xs: '0',
    xxs: '375px',
    sm: '767px',
    md: '1199px',
    lg: '1391px',
    xl: '1535px',
};
